import React from "react";

const SvgMouthDown = props => (
  <svg
    style={{
      isolation: "isolate"
    }}
    viewBox="0 0 205 200"
    {...props}
  >
    <defs>
      <clipPath id="MouthDown_svg__a">
        <path d="M0 0h205v200H0z" />
      </clipPath>
    </defs>
    <g clipPath="url(#MouthDown_svg__a)">
      <mask
        id="MouthDown_svg__b"
        x="-200%"
        y="-200%"
        width="400%"
        height="400%"
      >
        <rect x="-200%" y="-200%" width="400%" height="400%" fill="#fff" />
        <path d="M131.01 90.32l-3.84 9.62 62.36-5.72a1.578 1.578 0 0 0 1-2.7l-1.7-1.7-57.82.5z" />
      </mask>
      <path
        d="M131.01 90.32l-3.84 9.62 62.36-5.72a1.578 1.578 0 0 0 1-2.7l-1.7-1.7-57.82.5z"
        fill="#FFF"
        mask="url(#MouthDown_svg__b)"
        strokeWidth={4}
        stroke="#1D1D1B"
        strokeMiterlimit={10}
      />
    </g>
  </svg>
);

export default SvgMouthDown;